export const blockIconsNavigationChevronRight = (
	<span className='material-symbols-outlined'>chevron_right</span>
);
